
export const regExPattern = {
  phone: "^[0-9]{10}$",
  // email: "^[A-Za-z0-9\._%+\-]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,}$",
  // email:"^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$",
  email:"^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$",
  name: "^[a-zA-Z][a-zA-Z0-9_ &]{1,}$",//add & in this pattern by shahir hussain for allow & character -05-05-25
  pinCode: "^[0-9]{0,}$",
  gstNo: "^[a-zA-Z0-9]{0,}$",
  password: "^[a-zA-Z0-9.,@#_ ]{6,}$",
  quantity: "^[0-9]{0,}$",
  amount:"^[0-9]{0,}$",
};
